import { NavLink } from 'react-router-dom';

import { useAuthStore } from '@/features/auth/store/authStore.js';
import { Logo } from '@/shared/components/Logo.js';

import { NAV_ITEMS } from './nav-items.js';

export function Sidebar(): JSX.Element {
  const isSuperadmin = useAuthStore(
    (s) => s.user?.role === 'superadmin',
  );
  const items = isSuperadmin
    ? [...NAV_ITEMS, { to: '/admin', label: 'Admin', icon: '🛠️' }]
    : NAV_ITEMS;
  return (
    <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 flex-col gap-2 border-r border-cream-dark/60 bg-cream-dark/80 p-5 backdrop-blur lg:flex xl:w-72">
      <div className="flex items-center gap-3 border-b border-brown/5 px-2 pb-5">
        <Logo variant="mark" className="h-12 w-12 shrink-0" />
        <div className="flex flex-col leading-tight">
          <span className="font-serif text-xl font-semibold text-brown">Booknest</span>
          <span className="font-script text-sm text-brown-soft">
            ta bibliothèque enchantée
          </span>
        </div>
      </div>

      <nav className="mt-2 flex flex-1 flex-col gap-1">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-semibold transition-colors ${
                isActive
                  ? 'bg-paper text-terracotta-dark shadow-sm'
                  : 'text-brown-soft hover:bg-paper/60 hover:text-brown'
              }`
            }
          >
            <span className="text-lg leading-none" aria-hidden>
              {item.icon}
            </span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="rounded-2xl bg-gradient-to-br from-terracotta to-terracotta-dark p-4 text-cream-light shadow-md">
        <p className="font-serif text-sm font-semibold">📚 Connecte ta Kindle</p>
        <p className="mt-1.5 text-xs leading-relaxed opacity-90">
          Synchronise tes lectures, surlignages et progression.
        </p>
        <button
          type="button"
          className="mt-3 rounded-full bg-cream-light px-3 py-1.5 text-xs font-semibold text-terracotta-dark hover:bg-paper"
        >
          Connecter
        </button>
      </div>
    </aside>
  );
}
